import { Injectable } from '@angular/core';
import { DecimalPipe } from 'app/shared/decimal.pipe';

declare const Mangler: any;

@Injectable({
	providedIn: 'any'
})
export class TaskService {

	stageFilter = 'all';
	billingstageFilter = 'all';
	projectFilter = [];
	workOrderFilter = [];
	systemFilter = [];
	areaFilter = [];
	labourTypeFilter = [];
	teamFilter = [];
	userFilter = [];
	phaseFilter = [];
	priorityFilter = [];
	invoiceFilter = [];

	expandedTasks = [];
	expandedTaskItems = [];
	expandedTaskMaterials = [];

	constructor() { }

	setTaskExpanded(id, state) {
		if (state) {
			if (!Mangler.first(this.expandedTasks, id)) this.expandedTasks.push(id);
		} else {
			Mangler.filter(this.expandedTasks, { $ne: id });
		}
		this.expandedTasks = this.expandedTasks.slice();
	}

	isTaskExpanded(id) {
		return !!Mangler.first(this.expandedTasks, id);
	}

	toggleTaskExpanded(id) {
		this.setTaskExpanded(id, !this.isTaskExpanded(id));
	}

	// material
	setTaskMaterialExpanded(id, state) {
		if (state) {
			if (!Mangler.first(this.expandedTaskMaterials, id)) this.expandedTaskMaterials.push(id);
		} else {
			Mangler.filter(this.expandedTaskMaterials, { $ne: id });
		}
		this.expandedTaskMaterials = this.expandedTaskMaterials.slice();
	}

	isTaskMaterialExpanded(id) {
		return !!Mangler.first(this.expandedTaskMaterials, id);
	}

	toggleTaskMaterialExpanded(id) {
		this.setTaskMaterialExpanded(id, !this.isTaskMaterialExpanded(id));
	}

	// items
	setTaskItemExpanded(id, state) {
		if (state) {
			if (!Mangler.first(this.expandedTaskItems, id)) this.expandedTaskItems.push(id);
		} else {
			Mangler.filter(this.expandedTaskItems, { $ne: id });
		}
		this.expandedTaskItems = this.expandedTaskItems.slice();
	}

	isTaskItemExpanded(id) {
		return !!Mangler.first(this.expandedTaskItems, id);
	}

	toggleTaskItemExpanded(id) {
		this.setTaskItemExpanded(id, !this.isTaskItemExpanded(id));
	}

	stageColor(stage, selected = true, defaultColor = 'secondary') {
		if (!selected) return defaultColor;

		switch (stage) {
			case 'all': return 'primary';
			case 'active': return 'success';
			case 'to_be_scheduled': return 'secondary';
			case 'scheduled': return 'info';
			case 'follow_up': return 'warning';
			case 'completed': return 'success';
			case 'in_progress': return 'secondary';
			case 'ready_for_so_quote': return 'info';
			case 'in_so_quote': return 'success';
		}
		return 'secondary';
	}

	stageDescription(stage) {
		switch (stage) {
			case 'all': return 'All';
			case 'active': return 'Active';
			case 'to_be_scheduled': return 'To Be Scheduled';
			case 'scheduled': return 'Scheduled';
			case 'follow_up': return 'Follow Up';
			case 'completed': return 'Completed';
			case 'in_progress': return 'In Progress';
			case 'ready_for_so_quote': return 'Ready for Sales Order/Quote';
			case 'in_so_quote': return 'In Sales Order/Quote';
		}
		return '';
	}

	stageList() {
		return ['all', 'to_be_scheduled', 'scheduled', 'active', 'follow_up', 'completed'];
	}

	resolveStageFilter(s = null) {
		if (!s) s = this.stageFilter;

		if (s === 'all') return null;
		return [s];
	}

	billingstageList() {
		return ['all', 'in_progress', 'ready_for_so_quote', 'in_so_quote'];
	}

	resolveBillingStageFilter(s = null) {
		if (!s) s = this.billingstageFilter;

		if (s === 'all') return null;
		return [s];
	}

	getFormattedDuration(duration: number, durationType: string): string {
		if (durationType === 'min') duration *= 60;
		const formattedDuration = DecimalPipe.transform(duration, 0, 2);

		if (durationType === 'min') return `${formattedDuration} ${formattedDuration === '1' ? 'min' : 'mins'}`;
		return `${formattedDuration} ${formattedDuration === '1' ? 'hour' : 'hours'}`;
	}

	clearExpanded() {
		this.expandedTasks = [];
		this.expandedTaskItems = [];
		this.expandedTaskMaterials = [];
	}

	clearFilters() {
		this.areaFilter = [];
		this.workOrderFilter = [];
		this.systemFilter = [];
		this.labourTypeFilter = [];
		this.teamFilter = [];
		this.userFilter = [];
		this.phaseFilter = [];
		this.projectFilter = [];
		this.priorityFilter = [];
		this.invoiceFilter = [];
	}

}
